import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';


export enum NetworkTypeEnum {
    twitter = MediaTypeEnum.TWITTER,
    facebook = MediaTypeEnum.FACEBOOK,
    instagram = MediaTypeEnum.INSTAGRAM,
    youtube = MediaTypeEnum.YOUTUBE,
    reddit = MediaTypeEnum.REDDIT,
    subReddit = 'REDDIT_SUBREDDIT',
    tiktok = MediaTypeEnum.TIKTOK,
    linkedin = MediaTypeEnum.LINKEDIN,
    bluesky = MediaTypeEnum.BLUESKY,
    all = 'ALL',
}

export const networkOptionsOrder: NetworkTypeEnum[] = [
    NetworkTypeEnum.twitter,
    NetworkTypeEnum.facebook,
    NetworkTypeEnum.instagram,
    NetworkTypeEnum.tiktok,
    NetworkTypeEnum.youtube,
    NetworkTypeEnum.reddit,
    NetworkTypeEnum.subReddit,
    NetworkTypeEnum.linkedin,
    NetworkTypeEnum.bluesky
];

export const networkTypeIconMap = new Map<NetworkTypeEnum, string>([
    [ NetworkTypeEnum.facebook,  'fa-brands fa-facebook'  ],
    [ NetworkTypeEnum.twitter,   'fa-brands fa-x-twitter' ],
    [ NetworkTypeEnum.instagram, 'fa-brands fa-instagram' ],
    [ NetworkTypeEnum.youtube,   'fa-brands fa-youtube'   ],
    [ NetworkTypeEnum.reddit,    'fa-brands fa-reddit'    ],
    [ NetworkTypeEnum.subReddit, 'fa-brands fa-reddit'    ],
    [ NetworkTypeEnum.tiktok,    'fa-brands fa-tiktok'    ],
    [ NetworkTypeEnum.linkedin,  'fa-brands fa-linkedin'  ],
    [ NetworkTypeEnum.bluesky,   'fa-brands fa-bluesky'   ],
]);


export const mediaTypeToNetwork = new Map<MediaTypeEnum, NetworkTypeEnum>([
    [ MediaTypeEnum.FACEBOOK,  NetworkTypeEnum.facebook  ],
    [ MediaTypeEnum.TWITTER,   NetworkTypeEnum.twitter   ],
    [ MediaTypeEnum.REDDIT,    NetworkTypeEnum.reddit    ],
    [ MediaTypeEnum.INSTAGRAM, NetworkTypeEnum.instagram ],
    [ MediaTypeEnum.YOUTUBE,   NetworkTypeEnum.youtube   ],
    [ MediaTypeEnum.TIKTOK,    NetworkTypeEnum.tiktok    ],
    [ MediaTypeEnum.LINKEDIN,  NetworkTypeEnum.linkedin  ],
    [ MediaTypeEnum.BLUESKY,   NetworkTypeEnum.bluesky   ],
]);

